import React, { useEffect, useState } from 'react'


type SaveAndExportIconProps = {
    isActive: boolean
    setIsActive: (isActive: boolean) => void
}
export const SaveAndExportIcon: React.FC<SaveAndExportIconProps> = (props) => {
    return (
        <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => props.setIsActive(!props.isActive)}
            className={props.isActive ? 'active' : ''}
            style={{ cursor: 'pointer', userSelect: 'none', width: '100%', height: '100%' }}
        >
            <style>{`
                .line {
                    stroke: #333;
                    stroke-width: 6;
                    stroke-linecap: round;
                    transform-origin: center;
                    transition: transform 0.3s ease-in-out, opacity 0.3s ease;
                }
                
                /* Горизонтальные линии (исходное состояние) */
                .line.top { transform: translateY(-20px) rotate(0deg); }
                .line.middle { opacity: 1; }
                .line.bottom { transform: translateY(20px) rotate(0deg); }
                
                /* Вертикальные линии (активное состояние) */
                .active .line.top { transform: translateX(-20px) rotate(90deg); stroke-width: 10; }
                .active .line.middle { opacity: 0; stroke-width: 10; } /* Скрываем среднюю */
                .active .line.bottom { transform: translateX(20px) rotate(90deg); stroke-width: 10; }
            `}</style>

            {/* Три линии — все центрированы по Y=50 для удобства трансформации */}
            <line className={`line top ${props.isActive ? 'active' : ''}`}
                x1="20" y1="50" x2="80" y2="50" />
            <line className={`line middle ${props.isActive ? 'active' : ''}`}
                x1="20" y1="50" x2="80" y2="50" />
            <line className={`line bottom ${props.isActive ? 'active' : ''}`}
                x1="20" y1="50" x2="80" y2="50" />
        </svg>
    )
}